module.exports = __webpack_public_path__ + "img/money.227d6731.svg";